// extracted by mini-css-extract-plugin
export var left = "index-module--left--nci0G";
export var panel = "index-module--panel--reRbd";
export var panelCopy = "index-module--panelCopy--SXYtR";
export var panelImage = "index-module--panelImage--pabQk";
export var right = "index-module--right--CBZGI";